export default __webpack_public_path__ + "static/media/web_screen_engage_ja.f4d88ef4.png";